/**
 * Constructor to create the placeholder on the input element.
 * @constructor
 * Detect the possibility of usage HTML5 placeholder,
 * otherwise is used custom placeholder.
 */
com.inq.ui.Placeholder = function(inputElement, intro) {
	this._element = inputElement;
	this._value = "";
	if (com.inq.utils.Capabilities.isWindowsPhone() || (!com.inq.utils.Util.isIE && "placeholder" in this._element)) {
		this._customPlaceholder = null;
	} else {
		this._customPlaceholder = new com.inq.ui.CustomPlaceholder(this);
	}

	this.setValue(intro);
};
$hxClasses.extend(com.inq.ui.Placeholder, com.inq.ui.Placeholder, "com.inq.ui.Placeholder");

com.inq.ui.Placeholder.prototype.toggle = function() {
	if (this._customPlaceholder) {
		this._customPlaceholder.toggle();
	}
};

com.inq.ui.Placeholder.prototype.getValue = function() {
	if (this._customPlaceholder) {
		return this._customPlaceholder.getValue();
	} else {
		return this._element.placeholder;
	}
};

com.inq.ui.Placeholder.prototype.setValue = function(value) {
	if (this._customPlaceholder) {
		this._customPlaceholder.setValue(value);
	} else {
		this._element.placeholder = value;
	}
};

com.inq.ui.Placeholder.prototype.clear = function() {
	this.setValue("");
};
